﻿export function apiUrls() {
    return {
        questionnaires: {
            selectableItems: "/Questionnaires",
            internalAssessment: "/Questionnaires/internalAssessment",
        },
        vendorClassifications: {
            selectableItems: "/Questionnaires/vendorclassifications",
        },
        internalAssessments: {
            selectableAssignees: "/internalAssessments/selectable-assignees",
        },
        legalEntities: {
            contacts: (legalEntityId: string) => `/LegalEntityContacts/${legalEntityId}/selectableContacts`,
            contactsOnAvaliableGroupEntities: `/LegalEntityContacts/availableContacts`,
            groupEntities: "/LegalEntity/selectablegroupentities",
        },
        systems: {
            selectableItems: "/System/selectableItems",
            selectableItemsByLegalEntityId: (legalEntityId: string) => `/System/selectableItems/${legalEntityId}`,
        },
        processingActivites: {
            selectableItemsByAccess: "/ProcessingActivity/selectableItemsByAccess",
        },
    };
}
